import { api } from "api/loginRoutes";
import { createAction } from "./defaults";
import { EXCEPTIONS_WRONG_LANG as PREFIX } from "const";
import {
    EXCEPTIONS_WRONG_LANG_SET_LOADING,
    EXCEPTIONS_WRONG_LANG_SET_LIST
} from "./actionTypes";
import {
    EXCEPTIONS_WRONG_LANG_GET_LIST_API,
    EXCEPTIONS_WRONG_LANG_CREATE_API,
    EXCEPTIONS_WRONG_LANG_MODIFY_API,
    EXCEPTIONS_WRONG_LANG_REMOVE_API
} from "const/apiMethods";


const setLoading = createAction(EXCEPTIONS_WRONG_LANG_SET_LOADING);
const setExceptionsWrongLangList = createAction(EXCEPTIONS_WRONG_LANG_SET_LIST);

export const setExceptionsWrongLangTrafficLoading = (value) => (dispatch) => {
    dispatch(setLoading(value));
};

export const getExceptionsWrongLangTrafficList = (filter) => async (dispatch) => {
    dispatch(setLoading(true));

    return await api(EXCEPTIONS_WRONG_LANG_GET_LIST_API, {filter}) // , page, per_page: perPage
        .then((response) => {
            // localStorage.setItem(PREFIX + "_per_page", perPage);

            dispatch(setExceptionsWrongLangList({
                list: response.sms_language_exception_list,
                // count: response.price_range_protected_count,
                // page,
                // perPage
            }));
        })
        .finally(() => dispatch(setLoading(false)));
};

export const createExceptionsWrongLangTraffic = (params) => (dispatch) => {
    return api(EXCEPTIONS_WRONG_LANG_CREATE_API, params);
};

export const modifyExceptionsWrongLangTraffic = (params) => (dispatch) => {
    return api(EXCEPTIONS_WRONG_LANG_MODIFY_API, params);
};

export const removeExceptionsWrongLangTraffic = (key) => (dispatch) => {
    const params = {
        sms_language_exception_key: key
    };
    return api(EXCEPTIONS_WRONG_LANG_REMOVE_API, params);
};